"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../theme/utils");
const Component = styled_components_1.default.h1(({ theme, color, altColor, margin, variant }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, (theme.TYPOGRAPHY[variant] || {})), { margin: (0, utils_1.getMargin)({ theme, margin }) }), (color ? { color: theme.COLOR[color] } : {})), (altColor ? { span: { color: theme.COLOR[altColor] } } : {}))));
const Heading = (props) => (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props), void 0);
exports.Heading = Heading;
//# sourceMappingURL=Heading.js.map